<template>
  <v-card class="elevation-10">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>
        <slot name="title"></slot>
      </v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-card-text>
      <v-form>
        <p class="subtitle-1 font-weight-bold mt-0 mb-3"> Жизненный цикл заказа </p>
        <v-row class="py-0">
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-order-supplier-edit-strategy v-model="form.executorEditStrategy" :disabled="isExecutorEditStrategyReadonly"
                                                 :error-messages="executorEditStrategyErrors"/>
          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-executor-create-invoice-strategy v-model="form.executorCreateInvoiceStrategy" :disabled="isExecutorCreateInvoiceStrategyReadonly"
                                                     :error-messages="executorCreateInvoiceStrategyErrors"/>
          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-shipment-delivery-date-strategy v-model="form.shipmentDeliveryDateStrategy" :disabled="isShipmentDeliveryDateStrategyReadonly"
                                                    :error-messages="shipmentDeliveryDateStrategyErrors"/>

          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-order-shipment-date-method-strategy v-model="form.orderShipmentDateMethodStrategy" :disabled="isOrderShipmentDateMethodStrategyReadOnly"
                                                        :error-messages="orderShipmentDateMethodStrategyErrors"/>
          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-order-product-name-define-method-strategy v-model="form.orderProductNameDefineMethodStrategy" :disabled="isOrderProductNameDefineMethodStrategyReadOnly"
                                                              :error-messages="orderProductNameDefineMethodStrategyErrors"/>
          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-order-contract-define-method-strategy v-model="form.orderContractDefineMethodStrategy" :disabled="isOrderContractDefineMethodStrategyReadOnly"
                                                          :error-messages="orderContractDefineMethodStrategyErrors"/>
          </v-col>
          <v-col cols="12" md="6" lg="4" xl="3">
            <select-order-item-quantity-limit-strategy v-model="form.orderItemQuantityLimitStrategy" :disabled="isOrderItemQuantityLimitStrategyReadonly"
                                                       :error-messages="orderItemQuantityLimitStrategyErrors"/>
          </v-col>
        </v-row>

        <v-divider class="mb-5"/>

        <p class="subtitle-1 font-weight-bold mt-0 mb-3"> Параметры заказа </p>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-container class="pa-0">
              <v-row no-gutters>
                <v-text-field label="Инн поставщика" v-model="form.executorInn" readonly type="text" :dense="true"
                              :error-messages="executorInnErrors" class="flex-grow-1" outlined :disabled="isHeaderItemsDisabled">
                </v-text-field>
                <select-company-dialog :small="true" v-model="executor" v-if="!isExecutorReadonly">
                  <template slot="button" slot-scope="{on}">
                    <v-btn text large color="primary" v-on="on" class="flex-shrink-0">
                      Выбрать
                    </v-btn>
                  </template>
                </select-company-dialog>
              </v-row>
            </v-container>

            <v-text-field label="Поставщик" v-model="form.executorName" readonly type="text" :dense="true"
                          :error-messages="executorNameErrors" outlined
                          :disabled="isHeaderItemsDisabled"/>

            <v-text-field
                label="Номер заказа"
                type="text"
                v-model="form.number"
                :error-messages="numberErrors"
                :disabled="isHeaderItemsDisabled"
                :dense="true"
                outlined
            />

            <date-input v-model="form.date" label="Дата заказа" :dense="true" :outlined="true"
                        :error-messages="dateErrors" :disabled="isHeaderItemsDisabled" :append-icon="true"
                        :prepend-icon="false"/>

            <v-text-field v-model="form.customerShipmentId" label="Идентификатор поставки в системе заказчика" outlined dense :hide-details="true"/>

<!--            <v-text-field v-model="form.customerSystemId" label="Идентификатор заказа в системе заказчика" outlined dense :hide-details="true"/>-->
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
                label="Номер договора"
                type="text"
                v-model="form.contractNumber"
                :error-messages="contractNumberErrors"
                :disabled="isHeaderItemsDisabled"
                :dense="true"
                outlined
            />

            <date-input v-model="form.contractDate" label="Дата договора" :dense="true" :outlined="true"
                        :error-messages="contractDateErrors" :disabled="isHeaderItemsDisabled" :append-icon="true"
                        :prepend-icon="false"/>

            <v-autocomplete v-model="branch"
                            :items="branches"
                            :item-value="value => value"
                            :item-text="item => {return `${item.name} (${item.ownerName})`}"
                            :label="label"
                            :error-messages="deliveryAddressErrors"
                            :disabled="isHeaderItemsDisabled"
                            :dense="true"
                            outlined
            />

            <date-input v-model="form.expireDate" :label="label1" :dense="true" :outlined="true"
                        :error-messages="expireDateErrors" :disabled="isHeaderItemsDisabled" :append-icon="true"
                        :prepend-icon="false"/>
          </v-col>
        </v-row>

        <v-divider class="my-5"/>

        <p class="subtitle-1 font-weight-bold my-5 d-flex"> Товары / услуги
        </p>
        <v-data-table :dense="true" :headers="headers" :items="form.items" class="no-gutters" :disable-pagination="true" :hide-default-footer="true">
          <template v-slot:header.delete>
            <v-btn icon color="success" @click="onAddItemClicked()">
              <v-icon>add</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.rowNumber="{item}">
            {{ getItemIndex(item) + 1 }}
          </template>
          <template v-slot:item.product="{item}">
            <v-text-field type="text" v-model="item.product" placeholder="Товар"
                          :error-messages="itemProductErrors(getItemIndex(item))" :disabled="isItemsDisabled" outlined
                          :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.customerSystemId="{item}">
            <v-text-field type="text" v-model="item.customerSystemId" placeholder="ИД позиции" :disabled="isItemsDisabled" outlined :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.customerShipmentItemId="{item}">
            <v-text-field type="text" v-model="item.customerShipmentItemId" placeholder="ИД позиции поставки" :disabled="isItemsDisabled" outlined :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.customerCode="{item}">
            <v-text-field type="text" v-model="item.customerCode" placeholder="штрих-код"
                          :error-messages="itemCustomerCodeErrors(getItemIndex(item))" :disabled="isItemsDisabled"
                          outlined :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.catalog="{item}">
            <SelectCatalogCodeDialog v-model="item.catalog" :default-value="item.catalog" :full-height="true" :disabled="isItemsDisabled"/>
          </template>

          <template v-slot:item.measurement="{item}">
            <v-text-field type="text" v-model="item.measurement" placeholder="Ед. изм." :error-messages="itemMeasurementErrors(getItemIndex(item))" :disabled="isItemsDisabled" outlined :hide-details="true"
                          :dense="true"/>
          </template>

          <template v-slot:item.quantity="{item}">
            <v-text-field type="number" v-model="item.quantity" placeholder="Количество"
                          :error-messages="itemQuantityErrors(getItemIndex(item))" @blur="calculateItem(item)"
                          :disabled="isQuantityItemsDisabled" outlined
                          :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.price="{item}">
            <v-text-field type="number" v-model="item.price" placeholder="Цена за единицу"
                          :error-messages="itemPriceErrors(getItemIndex(item))" @blur="calculateItem(item)"
                          :disabled="isItemsDisabled" outlined
                          :hide-details="true"
                          :dense="true"
            />
          </template>

          <template v-slot:item.total="{item}">
            <v-text-field type="number" v-model="item.total" readonly placeholder="Стоимость"
                          :disabled="isItemsDisabled" outlined :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.ndsRate="{item}">
            <select-nds-rate v-model="item.ndsRate" :disabled="isItemsDisabled" @blur="calculateItem(item)"
                             @change="calculateItem(item)" :hide-details="true" :hide-label="true"/>
          </template>

          <template v-slot:item.ndsValue="{item}">
            <v-text-field type="number" v-model="item.ndsValue" readonly placeholder="Сумма НДС" outlined
                          :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.totalWithNds="{item}">
            <v-text-field type="number" v-model="item.totalWithNds" readonly placeholder="Стоимость с учётом НДС"
                          outlined :hide-details="true" :dense="true"/>
          </template>

          <template v-slot:item.delete="{item}">
            <v-btn color="error" small icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <span class="red--text" v-if="$v.form.items.$dirty && !$v.form.items.required">Необходимо включить минимум один товар</span>
      <v-spacer/>
      <v-btn color="blue darken-1" text @click="onSaveClicked()">Сохранить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import BranchService from '@/services/branch.service'

import MathHelper from '@/helpers/math'
import _ from 'underscore';

import {validationMixin} from 'vuelidate'
import {required, decimal, minValue, maxLength, minLength, numeric, and} from 'vuelidate/lib/validators'
import SelectCatalogCodeDialog from "@/components/Select/SelectCatalogCodeDialog";
import SelectCompanyDialog from "@/components/Select/SelectCompanyDialog";
import DateInput from "@/components/Input/DateInput";
import SelectOrderSupplierEditStrategy from "@/components/Select/SelectOrderSupplierEditStrategy";
import SelectExecutorCreateInvoiceStrategy from "@/components/Select/SelectExecutorCreateInvoiceStrategy";
import SelectShipmentDeliveryDateStrategy from "@/components/Select/SelectShipmentDeliveryDateStrategy";
import SelectOrderShipmentDateMethodStrategy from "@/components/Select/SelectOrderShipmentDateMethodStrategy";
import SelectOrderProductNameDefineMethodStrategy from "@/components/Select/SelectOrderProductNameDefineMethodStrategy";
import SelectOrderContractDefineMethodStrategy from "@/components/Select/SelectOrderContractDefineMethodStrategy";
import SelectOrderItemQuantityLimitStrategy from "@/components/Select/SelectOrderItemQuantityLimitStrategy";
import SelectNdsRate from "@/components/Select/SelectNdsRate";
import * as OrderExecutorEditStrategies from '@/enum/OrderExecutorEditStrategyType'
import moment from 'moment';

export default {
  name: "OrderForm",
  mixins: [validationMixin],
  components: {
    SelectNdsRate,
    SelectShipmentDeliveryDateStrategy,
    SelectExecutorCreateInvoiceStrategy,
    SelectOrderSupplierEditStrategy,
    SelectOrderShipmentDateMethodStrategy,
    SelectOrderProductNameDefineMethodStrategy,
    SelectOrderContractDefineMethodStrategy,
    SelectOrderItemQuantityLimitStrategy,
    DateInput,
    SelectCompanyDialog,
    SelectCatalogCodeDialog,
  },
  props: {
    isExecutor: {
      type: Boolean,
      default: false
    },
    customerInn: {
      type: String,
      default: null
    },
    orderInfo: {
      type: Object,
      default() {
        return null
      }
    },
    isNumberUniqueError: {
      type: Boolean,
      default: false
    },
    label:{
      type:String,
      default:""
    },
    label1:{
      type:String,
      default:""
    }
  },

  data() {
    return {
      executor: null,
      branch: null,
      branches: [],
      form: {
        customerSystemId: null,
        customerShipmentId: null,

        executorEditStrategy: null,
        executorCreateInvoiceStrategy: null,
        shipmentDeliveryDateStrategy: null,
        orderShipmentDateMethodStrategy: null,
        orderProductNameDefineMethodStrategy: null,
        orderContractDefineMethodStrategy: null,
        orderItemQuantityLimitStrategy: null,
        executorInn: '',
        executorName: '',
        number: '',
        date: null,
        contractNumber: '',
        contractDate: null,
        expireDate: null,
        branch: null,
        deliveryAddress: '',
        items: [],
      }
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          text: '#',
          value: 'rowNumber',
          align: 'center',
          sortable: false,
          filterable: false,
          cellClass: 'font-weight-bold',
          width: '20'
        },
        {
          text: 'Товар',
          value: 'product',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: ''
        },
        {
          text: 'ИД позиции поставки',
          value: 'customerShipmentItemId',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '140'
        },
        {
          text: 'Товар код',
          value: 'customerCode',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '140'
        },
        {
          text: 'ИКПУ код',
          value: 'catalog',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '1'
        },
        {
          text: 'Ед. изм.',
          value: 'measurement',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '100'
        },
        {
          text: 'Кол-во',
          value: 'quantity',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '100'
        },
        {
          text: 'Цена за единицу',
          value: 'price',
          align: 'start',
          sortable: false,
          filterable: false,
          cellClass: 'text-left pa-0',
          width: '120'
        },
        {
          text: 'Стоимость',
          value: 'total',
          align: 'center',
          sortable: false,
          filterable: false,
          cellClass: 'text-center pa-0',
          width: '160'
        },
        {
          text: 'Ставка НДС в %',
          value: 'ndsRate',
          align: 'center',
          sortable: false,
          filterable: false,
          cellClass: 'text-center pa-0',
          width: '125'
        },
        {
          text: 'Сумма НДС',
          value: 'ndsValue',
          align: 'center',
          sortable: false,
          filterable: false,
          cellClass: 'text-center pa-0',
          width: '160'
        },
        {
          text: 'Стоимость с учётом НДС',
          value: 'totalWithNds',
          align: 'center',
          sortable: false,
          filterable: false,
          cellClass: 'text-center pa-0',
          width: '160'
        },
      ]

      if (!this.isItemsAddDeleteDisabled) {
        headers.push({
          text: '',
          value: 'delete',
          align: 'center',
          sortable: false,
          filterable: false,
          class: '',
          cellClass: 'text-right pa-0',
          width: '20'
        })
      }

      return headers
    },

    // errors
    executorInnErrors() {
      const errors = [];

      if (this.$v.form.executorInn.$dirty) {
        if (!this.$v.form.executorInn.required)
          errors.push('Обязательно');
        else {
          (
              !this.$v.form.executorInn.minLength
              || !this.$v.form.executorInn.maxLength
              || !this.$v.form.executorInn.format
          )
          && errors.push('Введите ровно 9 цифр');
        }
      }

      return errors;
    },
    executorNameErrors() {
      const errors = [];

      if (this.$v.form.executorName.$dirty) {
        if (!this.$v.form.executorName.required)
          errors.push('Обязательно');
        else {
          !this.$v.form.executorName.maxLength && errors.push('Слишком длинное');
        }
      }

      return errors;
    },
    numberErrors() {
      const errors = [];

      if (this.$v.form.number.$dirty) {
        if (!this.$v.form.number.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.number.maxLength && errors.push('Слишком длинное значение');
        }

        this.isNumberUniqueError && errors.push('Заказ с таким номером уже существует')
      }

      return errors;
    },
    dateErrors() {
      const errors = [];

      if (this.$v.form.date.$dirty)
        if (!this.$v.form.date.required)
          errors.push('Обязательно');

      return errors;
    },
    executorEditStrategyErrors() {
      const errors = [];

      if (this.$v.form.executorEditStrategy.$dirty)
        if (!this.$v.form.executorEditStrategy.required)
          errors.push('Обязательно');

      return errors;
    },
    executorCreateInvoiceStrategyErrors() {
      const errors = [];

      if (this.$v.form.executorCreateInvoiceStrategy.$dirty)
        if (!this.$v.form.executorCreateInvoiceStrategy.required)
          errors.push('Обязательно');

      return errors;
    },
    shipmentDeliveryDateStrategyErrors() {
      const errors = [];

      if (this.$v.form.shipmentDeliveryDateStrategy.$dirty)
        if (!this.$v.form.shipmentDeliveryDateStrategy.required)
          errors.push('Обязательно');

      return errors;
    },
    orderShipmentDateMethodStrategyErrors() {
      const errors = [];

      if (this.$v.form.orderShipmentDateMethodStrategy.$dirty)
        if (!this.$v.form.orderShipmentDateMethodStrategy.required)
          errors.push('Обязательно');

      return errors;
    },
    orderProductNameDefineMethodStrategyErrors() {
      const errors = []
      if (this.$v.form.orderProductNameDefineMethodStrategy.$dirty)
        if (!this.$v.form.orderProductNameDefineMethodStrategy.required)
          errors.push('Обязательно');

      return errors;
    },
    orderContractDefineMethodStrategyErrors() {
      const errors = []
      if (this.$v.form.orderContractDefineMethodStrategy.$dirty)
        if (!this.$v.form.orderContractDefineMethodStrategy.required)
          errors.push('Обязательно');

      return errors
    },
    orderItemQuantityLimitStrategyErrors() {
      const errors = []
      if (this.$v.form.orderItemQuantityLimitStrategy.$dirty)
        if (!this.$v.form.orderItemQuantityLimitStrategy.required)
          errors.push('Обязательно');

      return errors
    },
    contractNumberErrors() {
      const errors = [];

      if (this.$v.form.contractNumber.$dirty) {
        if (!this.$v.form.contractNumber.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.contractNumber.maxLength && errors.push('Слишком длинное значение');
        }
      }

      return errors;
    },
    contractDateErrors() {
      const errors = [];

      if (this.$v.form.contractDate.$dirty)
        if (!this.$v.form.contractDate.required)
          errors.push('Обязательно');

      return errors;
    },
    expireDateErrors() {
      const errors = [];

      if (this.$v.form.expireDate.$dirty)
        if (!this.$v.form.expireDate.required)
          errors.push('Обязательно');


      return errors;
    },
    deliveryAddressErrors() {
      const errors = [];

      if (this.$v.form.deliveryAddress.$dirty) {
        if (!this.$v.form.deliveryAddress.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.deliveryAddress.maxLength && errors.push('Слишком длинное значение');
        }
      }

      if (this.$v.form.branch.$dirty)
        if (!this.$v.form.branch.required)
          errors.push('Выберите место доставки из спика');

      return errors;
    },

    // access to change properties
    isExecutorReadonly() {
      return !!this.isExecutor;
    },
    isExecutorEditStrategyReadonly() {
      return !!this.isExecutor;
    },
    isExecutorCreateInvoiceStrategyReadonly() {
      return !!this.isExecutor;
    },
    isShipmentDeliveryDateStrategyReadonly() {
      return !!this.isExecutor;
    },
    isOrderShipmentDateMethodStrategyReadOnly() {
      return !!this.isExecutor;
    },
    isOrderProductNameDefineMethodStrategyReadOnly() {
      return !!this.isExecutor;
    },
    isOrderContractDefineMethodStrategyReadOnly() {
      return !!this.isExecutor;
    },
    isOrderItemQuantityLimitStrategyReadonly() {
      return !!this.isExecutor;
    },
    isHeaderItemsDisabled() {
      return !!this.isExecutor;
    },
    isItemsDisabled() {
      return this.isExecutor
          && this.form.executorEditStrategy
          && this.form.executorEditStrategy !== OrderExecutorEditStrategies.All.id;
    },
    isQuantityItemsDisabled() {
      return this.isExecutor
          && this.form.executorEditStrategy
          && this.form.executorEditStrategy === OrderExecutorEditStrategies.Disabled.id;
    },
    isItemsAddDeleteDisabled() {
      return this.isExecutor
    },
  },
  validations: {
    form: {
      executorInn: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
        format: numeric
      },
      executorName: {
        required,
        maxLength: maxLength(300)
      },

      executorEditStrategy: {
        required,
      },
      executorCreateInvoiceStrategy: {
        required,
      },
      shipmentDeliveryDateStrategy: {
        required,
      },
      orderShipmentDateMethodStrategy: {
        required,
      },
      orderProductNameDefineMethodStrategy: {
        required,
      },
      orderContractDefineMethodStrategy: {
        required
      },
      orderItemQuantityLimitStrategy: {
        required
      },
      number: {
        required,
        maxLength: maxLength(100)
      },
      date: {
        required
      },
      contractNumber: {
        required,
        maxLength: maxLength(100)
      },
      contractDate: {
        required
      },
      expireDate: {
        required
      },
      deliveryAddress: {
        required,
        maxLength: maxLength(200)
      },
      branch: {
        required,
      },
      items: {
        required,
        minLength: minLength(1),
        $each: {
          product: {
            required,
            maxLength: maxLength(200),
          },
          measurement: {
            required,
            maxLength: maxLength(100)
          },
          customerCode: {
            maxLength: maxLength(50)
          },
          quantity: {
            required,
            decimal,
            strategy(value, item) {
              const quantity = +item.quantity
              if (this.isExecutor) {
                if (this.form.executorEditStrategy === OrderExecutorEditStrategies.ItemQuantityToLowerValueOnly.id) {
                  let itemIndex = -1;
                  _.each(this.form.items, (formItem, index) => {
                    if (formItem === item)
                      itemIndex = index;
                  });

                  if (itemIndex > -1 && itemIndex < this.orderInfo.items.length) {
                    return 0 < quantity && quantity <= this.orderInfo.items[itemIndex].quantity;
                  } else {
                    return false;
                  }
                }
              }
              return true;
            },
            minValue: minValue(0),
            numeric
          },
          price: {
            required,
            decimal,
            minValue: and(minValue(0), function (v) {
              return v > 0;
            })
          },
        }
      },
    }
  },

  methods: {
    deleteItem(item) {
      this.form.items = _.filter(this.form.items, i => {
        return item !== i
      });
    },

    getItemIndex(item) {
      return this.form.items.indexOf(item)
    },
    addItem() {
      let ndsRate = null
      if (this.form.items.length > 0)
        ndsRate = this.form.items[this.form.items.length - 1].ndsRate

      let item = {
        id: this.form.items.length,
        customerSystemId: null,
        customerShipmentItemId: null,
        productCode: null,

        product: '',
        catalog: null,
        customerCode: '',
        measurement: '',
        quantity: 0,
        price: 0,
        total: 0,
        ndsRate: ndsRate,
        ndsValue: 0,
        totalWithNds: 0
      }

      this.form.items.push(item);
      return item
    },

    calculateItem(item) {
      item.total = MathHelper.multiply(item.price, item.quantity);

      const ndsMultiplier = MathHelper.multiply(item.ndsRate, 0.01);
      item.ndsValue = MathHelper.multiply(item.total, ndsMultiplier);

      item.totalWithNds = item.total + item.ndsValue;
    },

    onSaveClicked() {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$emit('submit', this.form);
      }
    },
    onAddItemClicked() {
      this.addItem();
    },

    itemProductErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].product.$dirty)
        if (!this.$v.form.items.$each[index].product.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.items.$each[index].product.maxLength && errors.push('Слишком длинное значение');
        }

      return errors;
    },
    itemCustomerCodeErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].customerCode.$dirty)
        !this.$v.form.items.$each[index].customerCode.maxLength && errors.push('Слишком длинное значение');

      return errors;
    },
    itemMeasurementErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].measurement.$dirty)
        if (!this.$v.form.items.$each[index].measurement.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.items.$each[index].measurement.maxLength && errors.push('Слишком длинное значение');
        }
      return errors;
    },
    itemQuantityErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].quantity.$dirty) {
        if (!this.$v.form.items.$each[index].quantity.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.items.$each[index].quantity.decimal && errors.push('Неверный формат числа');
          !this.$v.form.items.$each[index].quantity.strategy && errors.push('Недоступное значение');
          !this.$v.form.items.$each[index].quantity.minValue && errors.push('Недоступное значение');
        }
      }
      return errors;
    },
    itemPriceErrors(index) {
      const errors = [];
      if (this.$v.form.items.$each[index].price.$dirty) {
        if (!this.$v.form.items.$each[index].price.required) {
          errors.push('Обязательно');
        } else {
          !this.$v.form.items.$each[index].price.decimal && errors.push('Неверный формат числа');
          !this.$v.form.items.$each[index].price.minValue && errors.push('Недоступное значение');
        }
      }
      return errors;
    },

    loadBranches() {
      BranchService.getCompanyBranches(this.customerInn).then(response => {
        this.branches = response.data.map(branch => {
          return {
            id: branch.Id,
            code: branch.Code,
            name: branch.Name,
            ownerInn: branch.OwnerInn,
            ownerName: branch.OwnerName
          }
        })
        if (this.orderInfo) {
          this.branch = this.branches.find(x => x.id === this.orderInfo.branch) || null
        }
      });
    },
    reloadFromOrderInfo() {
      if (this.orderInfo) {
        this.form.customerSystemId = this.orderInfo.customerSystemId
        this.form.customerShipmentId = this.orderInfo.customerShipmentId
        this.form.executorEditStrategy = this.orderInfo.executorEditStrategy.id
        this.form.executorCreateInvoiceStrategy = this.orderInfo.executorCreateInvoiceStrategy.id
        this.form.shipmentDeliveryDateStrategy = this.orderInfo.shipmentDeliveryDateStrategy.id
        this.form.orderShipmentDateMethodStrategy = this.orderInfo.shipmentDateMethodStrategy.id
        this.form.orderProductNameDefineMethodStrategy = this.orderInfo.productNameDefineMethodStrategy.id
        this.form.orderContractDefineMethodStrategy = this.orderInfo.contractDefineMethodStrategy.id
        this.form.orderItemQuantityLimitStrategy = this.orderInfo.itemQuantityLimitStrategy.id
        this.form.executorInn = this.orderInfo.executorInn
        this.form.executorName = this.orderInfo.executorName
        this.form.number = this.orderInfo.number
        this.form.date = moment(this.orderInfo.date)
        this.form.contractNumber = this.orderInfo.contractNumber
        this.form.contractDate = moment(this.orderInfo.contractDate)
        this.form.expireDate = moment(this.orderInfo.expireDate)
        this.form.branch = this.orderInfo.branch
        this.form.deliveryAddress = this.orderInfo.deliveryAddress
        this.form.items = []

        for (let i = 0; i < this.orderInfo.items.length; i++) {
          let item = this.addItem()

          item.id = this.orderInfo.items[i].id
          item.product = this.orderInfo.items[i].product
          item.productCode = this.orderInfo.items[i].productCode
          item.catalog = this.orderInfo.items[i].catalogCode
          item.customerCode = this.orderInfo.items[i].customerCode
          item.measurement = this.orderInfo.items[i].measurement
          item.quantity = this.orderInfo.items[i].quantity
          item.price = this.orderInfo.items[i].price
          item.total = this.orderInfo.items[i].total
          item.ndsRate = this.orderInfo.items[i].ndsRate
          item.ndsValue = this.orderInfo.items[i].ndsValue
          item.totalWithNds = this.orderInfo.items[i].totalWithNds
          item.customerSystemId = this.orderInfo.items[i].customerSystemId
          item.customerShipmentItemId = this.orderInfo.items[i].customerShipmentItemId
          item.productCode = this.orderInfo.items[i].productCode

          this.calculateItem(item)
        }
      }
    }
  },
  watch: {
    executor(newV) {
      if (newV) {
        this.form.executorInn = newV.inn;
        this.form.executorName = newV.name;
      }
    },
    branch() {
      if (this.branch) {
        this.form.branch = this.branch.id
        this.form.deliveryAddress = this.branch.name
      } else {
        this.form.branch = null
        this.form.deliveryAddress = null
      }
    },
    orderInfo() {
      if (this.orderInfo) {
        this.reloadFromOrderInfo()
      }
    }
  },
  created() {
    this.addItem();
    this.reloadFromOrderInfo()
    this.loadBranches()
  }
}
</script>

<style lang="scss">
.v-data-table.no-gutters table tr td {
  padding: 0 !important
}
</style>